import { render } from "./SetUpProviderModal.vue?vue&type=template&id=0af1ced8&scoped=true"
import script from "./SetUpProviderModal.vue?vue&type=script&lang=js"
export * from "./SetUpProviderModal.vue?vue&type=script&lang=js"

import "./SetUpProviderModal.vue?vue&type=style&index=0&id=0af1ced8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af1ced8"]])

export default __exports__